import $ from 'jquery';

import '../../../mui/dialog';

export default class TempLimitsNotification {
    constructor(ui) {
        const device_id = this.device_id_of_last_event();
        if (device_id != null && this.enabled(ui)) {
            const dialog = $.mui.mui_dialog
                .messagebox({
                    width: 360,
                    title: 'Уведомления о выходе температуры за пороги',
                    message:
                        '\
Если вы каждый час получаете оповещения о&nbsp;выходе температуры за&nbsp;установленные \
пороги, то&nbsp;проверьте настройки температурных порогов в&nbsp;меню \
<a href="#">Настройки&nbsp;→&nbsp;Датчики температуры</a>. \
Возможно, значения порогов нужно обновить.\
',
                    close: () => this.disable(ui),
                })
                .find('a')
                .on('click', () => {
                    ui.open_device_settings_dialog('thermostat_sensors');
                    dialog.mui_dialog('close');
                    return false;
                })
                .end();
        }
    }

    device_id_of_last_event() {
        const errors = PRELOAD.important_events.filter((event) =>
            ['TemperatureHigh', 'TemperatureLow'].includes(event.type)
        );
        return errors[0]?.device_id;
    }

    enabled(ui) {
        return (
            window.cordova == null &&
            ui.settings.data().templimits_notification_disabled !== true
        );
    }

    disable(ui) {
        ui.settings.set({templimits_notification_disabled: true});
    }
}
